import axios from '../../../utils/axios'

export default {
    getTemplates () {
        return axios.get('/training/template')
            .then(response => {
                return response.data
            })
    },

    getTemplate (id) {
        return axios.get('/training/template/' + id)
            .then(response => {
                return response.data
            })
    },

    createTemplate (data) {
        return axios.post('/training/template', data)
    },

    updateTemplate (id, data) {
        return axios.put('/training/template/' + id, data)
    },

    deleteTemplate (id) {
        return axios.delete('training/template/' + id)
    },

    getCourses () {
        return axios.get('training/course')
            .then(response => {
                return response.data
            })
    },

    getProducts () {
        return axios.get('training/product')
            .then(response => {
                return response.data
            })
    },

}
